var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 150,
    viewBox: "0 0 208 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xEB\x8B\xA4\xEC\x86\x94\xEC\x94\xA8\xEC\x95\x84\xEC\x9D\xB4\xEB\x94\x94"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    width: 208,
    height: 150,
    rx: 5,
    fill: "#E5E7EB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "imagesmode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1512_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 63,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 92,
    y: 63,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1512_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "imagesmode_2",
    d: "M97.3077 83.5C96.8026 83.5 96.375 83.325 96.025 82.975C95.675 82.625 95.5 82.1974 95.5 81.6923V68.3077C95.5 67.8026 95.675 67.375 96.025 67.025C96.375 66.675 96.8026 66.5 97.3077 66.5H110.692C111.197 66.5 111.625 66.675 111.975 67.025C112.325 67.375 112.5 67.8026 112.5 68.3077V81.6923C112.5 82.1974 112.325 82.625 111.975 82.975C111.625 83.325 111.197 83.5 110.692 83.5H97.3077ZM97.3077 82H110.692C110.769 82 110.84 81.9679 110.904 81.9038C110.968 81.8397 111 81.7692 111 81.6923V68.3077C111 68.2308 110.968 68.1602 110.904 68.0961C110.84 68.032 110.769 68 110.692 68H97.3077C97.2308 68 97.1603 68.032 97.0962 68.0961C97.0321 68.1602 97 68.2308 97 68.3077V81.6923C97 81.7692 97.0321 81.8397 97.0962 81.9038C97.1603 81.9679 97.2308 82 97.3077 82ZM99.6539 79.75H108.423C108.604 79.75 108.738 79.6679 108.825 79.5038C108.912 79.3397 108.899 79.1807 108.785 79.0269L106.4 75.8327C106.306 75.7122 106.186 75.6519 106.038 75.6519C105.891 75.6519 105.771 75.7122 105.677 75.8327L103.231 79.0192L101.592 76.9192C101.499 76.8051 101.38 76.7481 101.236 76.7481C101.091 76.7481 100.972 76.8083 100.879 76.9289L99.302 79.0269C99.1815 79.1807 99.1648 79.3397 99.252 79.5038C99.3392 79.6679 99.4731 79.75 99.6539 79.75ZM100.5 72.75C100.846 72.75 101.141 72.6282 101.385 72.3846C101.628 72.141 101.75 71.8461 101.75 71.5C101.75 71.1538 101.628 70.859 101.385 70.6154C101.141 70.3718 100.846 70.25 100.5 70.25C100.154 70.25 99.859 70.3718 99.6154 70.6154C99.3718 70.859 99.25 71.1538 99.25 71.5C99.25 71.8461 99.3718 72.141 99.6154 72.3846C99.859 72.6282 100.154 72.75 100.5 72.75Z",
    fill: "#888888"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.5def2d5a7931be03fb30430491d56ef5.svg";
export { ForwardRef as ReactComponent };